export const PROMPT_TEMPLATES = [
  {
    title: 'formal',
    event: 'promptTemplateFormalClicked',
    value:
      'Translate this video in a formal tone of voice. Maintain professional language suitable for a business setting, and avoid informal expressions. Include terms appropriate to a friendly, informative, or enthusiastic style, as specified. Do not use the following terms: [insert terms].',
  },
  {
    title: 'informal',
    event: 'promptTemplateInformalClicked',
    value:
      'Translate this video in an informal tone of voice. Use conversational language to make the content approachable and friendly. Adapt expressions to match a friendly, informative, or enthusiastic style, as specified. Avoid using the following terms: [insert terms].',
  },
  {
    title: 'industry specific',
    event: 'promptTemplateIndustrySpecificClicked',
    value:
      'Translate this video using terminology specific to [industry/field]. Refer to our website [website link] for preferred terms and language.',
  },
] as const;

export const USER_PROMPT_FAQ_LINK = 'https://help.rask.ai/hc/introducing-prompting?hs_preview=TPLVFesG-223585063116';
